import React from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { SectionMidTitle } from 'components/FormHelper/SectionMidTitle';
import { PageTitle } from 'components/PageTitle/PageTitle';
import { SubTitle } from 'components/SubTitle/SubTitle';
import { Text } from 'components/Text';

import './LvnIncidents.scss';

const LVNIncidentsEditConfig = {
  emptyLabel: 'LVN Incidents',
  isEmpty(props) {
    return !props;
  },
};

export const LVNIncidents = (props) => {
  const isEditor = Utils.isInEditor();

  const handleCall = () => {
    window.location.href = 'tel:+498005396380';
  };

  return (
    <div className="lvn-incidents">
      <div className="lvn-incidents__header">
        <PageTitle text="Störung melden" />
        <SubTitle text="Teilen Sie uns Störungen Ihrer Stromversorgung mit" />
      </div>

      <div className="lvn-incidents__content">
        <Text
          text="Die LEW Verteilnetz GmbH steht für eine sichere Stromversorgung. Wenn Sie jedoch einmal
            eine Störung feststellen, dann helfen wir Ihnen gerne <strong>rund um die Uhr</strong>
            weiter
          "
          richText
        />
        <br />
        <Text
          text="
          Die Polizei oder Feuerwehr kann im Normalfall keine konkrete Aussage über Art oder Dauer
          einer Stromstörung machen."
          richText
        />
        <Text
          text=" Bitte rufen Sie deshalb unsere <strong>Störungshotline</strong> an:"
          richText
        />

        <div className="lvn-incidents__hotline">
          <SectionMidTitle>Kostenfreie Störungshotline</SectionMidTitle>
          <ActionButton title="0800 539 638 0" onClick={handleCall} />
        </div>
      </div>
    </div>
  );
};

MapTo('e-fix/components/content/lvnincidents')(LVNIncidents, LVNIncidentsEditConfig);
